/**
 * Registry of known `data-cta` names (spec: marketing-cta-capture, unknown-name governance).
 *
 * Deliberately NOT a closed type: capture must never depend on a type edit — the previous
 * closed enum (`page_location`) drifted to 100% wrong within weeks of the site relaunch.
 * Unknown names are captured normally; dev builds log a warning pointing here, and a weekly
 * PostHog check flags values outside this list. Add new names here when they ship.
 */
export const KNOWN_CTA_NAMES = new Set(['get_started', 'request_demo', 'login'])

export const KNOWN_CTA_SECTIONS = new Set(['nav', 'hero', 'pricing_card', 'footer', 'inline', 'sticky'])
